import { useTranslation } from "react-i18next";
import { useGetTokenUsage } from "../../hooks/useGetTokenUsage";
import style from "./AiCreditsCard.module.css";

import Button from "@/ui/button/Button";
import { formatNumber } from "@/i18n/format";
import { useCurrentLanguage } from "@/i18n/useLocalized";

function AiCreditsCard() {
	const { t } = useTranslation();
	const { tokenUsage } = useGetTokenUsage();
	const language = useCurrentLanguage();

	const remaining = Math.round(
		Math.max(0, tokenUsage.token_limit - tokenUsage.tokens_used) / 1000
	);
	const percentage = Math.min(
		100,
		tokenUsage.token_limit == 0
			? 100
			: 100 * (tokenUsage.tokens_used / tokenUsage.token_limit)
	);

	return (
		<div className={style.card}>
			<div className={style.header}>
				<span>{t("ai:creditsCard.period")}</span>
			</div>
			<div className={style.body}>
				<span>
					{t("ai:creditsCard.remaining", {
						count: remaining,
						value: formatNumber(remaining, language),
					})}
				</span>
				<div className={style.progressHolder}>
					<div
						className={style.progress}
						style={{ width: `${percentage}%` }}
					></div>
				</div>
			</div>
		</div>
	);
}

export default AiCreditsCard;
